import React from "react";
import { Modal, Button } from "react-bootstrap";

const LogOutPopup = ({
    onCancel,
    onConfirm,
    headerLable,
    chldLable,
}) => {
    return (
        <>
            <Modal.Header closeButton onClick={() => onCancel(false)}></Modal.Header>
            <Modal.Body className="pb-4">
                <h3 className=""> {headerLable}</h3>
                <p className="text-gray-300 mb-0 mt-2 mb-5 h5">{chldLable}</p>
            </Modal.Body>

            <Modal.Footer className="justify-content-end btnFooter py-3 noShadow">

                <Button variant="white" size="" className="m-0" onClick={() => onCancel(false)}>
                    Cancel
                </Button>

                <Button
                    variant="primary"
                    size=""
                    className="border-0 m-0"
                    onClick={() => onConfirm()}
                >
                    Yes, Logout

                </Button>

            </Modal.Footer>
        </>
    );
};

export default LogOutPopup;
